import Risks from './Constructor'

export default Risks
export { Risks }
